import {NOTICE_TYPE} from '../actions/types';

const INITIAL_STATE = {
  title: '',
  describtion: '',
  type: null,
};

const notice = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case NOTICE_TYPE:
      return {
        ...state,
        title: action.payload.title,
        describtion: action.payload.describtion,
        type: action.payload.type,
      };
    default:
      return state;
  }
};

export default notice;
